import { useEffect, useState } from 'react';

import {
  OneTimeOrderSelection,
  OneTimeOrderPayment,
  OneTimeOrderConfirmation,
} from './Steps';
import { OneTimeOrderProvider, useOneTimeOrder } from './OneTimeOrderProvider';
import { ONE_TIME_ORDER_STEPS } from '../../utils/oneTimeOrder';
import { useFirebaseAuth } from '../../../global/FirebaseProvider/FirebaseProvider';
import LoadingBar from '../../global/LoadingBar';

import './OneTimeOrder.scss';

const OneTimeOrderContainer = () => (
  <OneTimeOrderProvider>
    <OneTimeOrder />
  </OneTimeOrderProvider>
);

const OneTimeOrder = () => {
  const {
    isLoading: isLoadingFirebaseAuth,
  } = useFirebaseAuth();
  const {
    isLoading: isLoadingConfig,
    step,
  } = useOneTimeOrder();

  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    // Allow users who already have active subscriptions to still make one-time purchases
    // Unlike subscriptions where we redirect if they have activeSubscription

    if (!isLoadingFirebaseAuth && !isLoadingConfig) {
      setHasMounted(true);
    }
  }, [
    isLoadingFirebaseAuth,
    isLoadingConfig,
  ]);

  const isLoading = !hasMounted && (isLoadingFirebaseAuth || isLoadingConfig);

  return (
    <div className="OneTimeOrder">
      <div className="OneTimeOrder__container">
        {isLoading ? (
          <LoadingBar className="OneTimeOrder__container-loader" />
        ) : (
          <>
            {step === ONE_TIME_ORDER_STEPS.SELECTION && <OneTimeOrderSelection />}
            {step === ONE_TIME_ORDER_STEPS.PAYMENT && <OneTimeOrderPayment />}
            {step === ONE_TIME_ORDER_STEPS.CONFIRMATION && <OneTimeOrderConfirmation />}
          </>
        )}
      </div>
    </div>
  );
};

export default OneTimeOrderContainer;
